import { render, staticRenderFns } from "./alert-warning-filled.vue?vue&type=template&id=213ced38"
import script from "./alert-warning-filled.vue?vue&type=script&lang=js"
export * from "./alert-warning-filled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports